import { AppState } from '../../model';

const reducer = (state, payload) => {
  switch (payload.type) {
    case 'UPDATE_STATE': {
      return new AppState(
        state.user,
        state.boards,
        state.pusher,
        state.dispatch,
      );
    }
    // Partner access: a board read or written through the partner routes. It
    // is held in THIS state, whichever state asked for it (see
    // AppState.holdSedeBoard).
    case 'HOLD_SEDE_BOARD': {
      return new AppState(
        state.user,
        AppState.withBoard(state.boards, payload.board),
        state.pusher,
        state.dispatch,
      );
    }
    case 'LOGIN_REQUEST': {
      if (payload.user) {
        state.user.login(payload.user);
      }
      return state;
    }
    case 'LOGOUT_REQUEST': {
      state.logout();
      return state;
    }
    case 'SET_ERROR': return state;
    default:
      return state;
  }
};

export default reducer;
